import { render } from "./ImportLicensesModal.vue?vue&type=template&id=286af51c"
import script from "./ImportLicensesModal.vue?vue&type=script&lang=js"
export * from "./ImportLicensesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__